<template>
  <v-container fluid class="mb-10">
    <v-row>
      <v-col cols="12">
        <v-card :loading="loading">
          <v-card-title>
            <h3>{{ global_settings }}</h3>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <boxEnambleStatus />
              </v-col>
              <v-col cols="12">
                <MatomoActivation />
              </v-col>
              <v-col cols="12">
                <FirstInteractionAskEmail />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card :loading="loading">
          <v-card-title>
            <h3>{{ messenger_settings }}</h3>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <ConfigMode />
              </v-col>
              <v-col cols="12">
                <stateMode />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ConfigMode from "@/components/settings/ConfigMode.vue";
import stateMode from "@/components/settings/StateMode.vue";
import boxEnambleStatus from "@/components/settings/BoxEnableStatus.vue";
import FirstInteractionAskEmail from "@/components/settings/FirstInteractionAskEmail.vue";
import MatomoActivation from "@/components/settings/MatomoActivation.vue";
export default {
  name: "Settings",
  components: {
    ConfigMode,
    stateMode,
    boxEnambleStatus,
    FirstInteractionAskEmail,
    MatomoActivation,
  },
  data() {
    return {
      loading: false,
      global_settings: "Global box settings :",
      messenger_settings: "Messenger Settings",
    };
  },
  async mouted() {},
};
</script>
